import { render, staticRenderFns } from "./MainCompiler.vue?vue&type=template&id=f4710b36&scoped=true&lang=html&"
import script from "./MainCompiler.vue?vue&type=script&lang=js&"
export * from "./MainCompiler.vue?vue&type=script&lang=js&"
import style0 from "./MainCompiler.vue?vue&type=style&index=0&id=f4710b36&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4710b36",
  null
  
)

export default component.exports